import { t } from '@/utils/i18n'
import React from 'react'

import styles from './BatchWarn.module.less'

interface WarnItem {
  elementName: string
  num: string | number
  unit: string
}

interface BatchWarnProps {
  warnList: WarnItem[]
  onClose: () => void
}

const BatchWarn: React.FC<BatchWarnProps> = (props) => {
  const { warnList, onClose } = props

  function handleClose() {
    onClose()
  }

  const WarnItem = () => {
    return warnList.map((item, index) => {
      return (
        <div key={index} className={styles['warn-item']}>
          <div className={styles['warn-name']}>
            {item.elementName}
          </div>
          <div className={styles['warn-number']}>
            <span className={styles['warn-num']}>{item.num}</span>
            <span className={styles['warn-unit']}>{item.unit}</span>
          </div>
        </div>
      )
    })
  }

  return (
    <div className={styles['kp-modal-wrapper']}>
      <div className={styles['kp-mask']}></div>
      <div className={styles['kp-modal']}>
        <div className={styles['title']}>{t('以下规格库存不足')}</div>
        <div className={styles['title']}>{t('已自动修改数量')}</div>
        <div className={styles['content']}>
          <WarnItem />
        </div>
        <div className={styles['kp-button-wrapper']}>
          <button
            className={styles['kp-confirm']}
            onClick={handleClose}
          >
            {t('确定')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default BatchWarn
